export const channels = [
  { id: 'tiendas', name: 'Tiendas' },
  { id: 'tigo-express', name: 'Tigo Express' },
  { id: 'islas', name: 'Islas' },
  { id: 'fvd-home', name: 'FVD Home' },
  { id: 'dealer-home', name: 'Dealer Home' },
];